import React, { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { sendResult } from "../../utils/helper";

// Style
import "./LevelDiez.scss";

// Assets
import circleIcon from "../../assets/images/level-diez/circle-empty.svg";
import circleDotIcon from "../../assets/images/level-diez/circle-dot.svg";
import circleHiddenIcon from "../../assets/images/level-diez/circle-dark.svg";

// Consts
import { CIRCLES_ARR } from "../../utils/consts";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

const LevelDiez = (props) => {
  const [circles, setCircles] = useState(CIRCLES_ARR);
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  const [dataPoints, setDataPoints] = useState({
    moveFirstTime: 0,
    firstDotTime: 0,
    totalTime: 0,
    totalClicks: 0,
  });

  // Clicks
  const [clicks, setClicks] = useState(0);

  // Timer
  const [timer, setTimer] = useState(0);

  // Timer increase
  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000);
  }, [timer]);

  useEffect(() => {
    let valid = true;
    circles.forEach((item) => {
      if (item.type != "hidden") {
        valid = false;
      }
    });
    if (valid) setWon(true);
    getDataPoints();
  }, [circles]);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        getDataPoints();
        const finalObj = {
          gameData: {
            levelData: [
              {
                level: 8,
                levelName: 'Center',
                moveFirstTime: dataPoints.moveFirstTime,
                firstDotTime: dataPoints.firstDotTime,
                totalTime: timer,
                totalClicks: clicks,
                isLevelCleared: true,
                isLevelSkipped: false,
                totalHintsTaken: localStorage.getItem("totalHints"),
                timeForFirstHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint1") : 0,
                timeForSecondHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint2") : 0
              }
            ],
          }
        }
        console.log(finalObj)
        sendResult(finalObj)
        setMove(true);
      }
    }, 500);
  }, [won]);

  const getDataPoints = (data) => {
    let tempDataPoints = { ...dataPoints };

    // Time taken to move first circle
    if (tempDataPoints.moveFirstTime === 0) {
      tempDataPoints.moveFirstTime = timer;
    }

    if (tempDataPoints.firstDotTime === 0 && data?.dot === true) {
      tempDataPoints.firstDotTime = timer;
    }

    if (won) {
      tempDataPoints.totalClicks = clicks;
      tempDataPoints.totalTime = timer;
    }

    setDataPoints(tempDataPoints);
  };

  const getCircleIcon = ({ item, index }) => {
    switch (item.type) {
      case "dot":
        return circleDotIcon;

      case "empty":
        return circleIcon;
      case "hidden":
        return circleHiddenIcon;
      default:
        break;
    }
  };

  const getZindex = ({ item, index }) => {
    if (item.x % 2 === 0) {
      return 1 * item.y;
    } else return 1 * item.y + 1;
  };

  const getTranslateY = ({ item, index }) => {
    if (item.x % 2 === 0) {
      return "80%";
    } else return "50%";
  };

  const popUp = ({ item, index }) => {
    setClicks(clicks + 1);
    let elem = document.querySelector(`#circle-${index}`);
    console.log(elem);
    elem.style.animation = "popup 1s linear";
    setTimeout(() => {
      elem.style.animation = "none";
      let tempData = [...circles];
      if (tempData[index].type === "dot") {
        getDataPoints({ dot: true });
        circles.forEach((data, i) => {
          if (data.x === item.x) {
            tempData[i].type = "hidden";
          }
        });
      }
      setCircles(tempData);
    }, 1000);
  };

  return (
    <div className="component-level-diez">
      {move && <LevelComplete levelNum={5} />}
      <Navbar won={won} levelNum={5} />
      <div className="game-div-diez">
        {circles.map((item, index) => (
          <div
            key={index}
            className="circle-div"
            style={{
              zIndex: getZindex({ item: item, index: index }),
              transform: `translateY(${getTranslateY({
                item: item,
                index: index,
              })})`,
            }}
          >
            <img
              id={`circle-${index}`}
              onClick={() => popUp({ item: item, index: index })}
              className="circle-img"
              src={getCircleIcon({ item: item, index: index })}
              alt="circle"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LevelDiez;
